import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import {
  getUnderlyingLiveFeed,
  getUnderlyingLiveFeedClosePrices,
} from '../../../../stores/underlying-live-feed/getters';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 11,
    fontWeight: 600,
    lineHeight: '16.9px',
    display: 'inline-flex',
    marginLeft: 5,
    color: 'var(--color-pnl-card-font-6)',

    [theme.breakpoints.up('md')]: {
      fontSize: 12,
    },
  },
}));

function calculatePriceGap(ltpPrice, closePrice) {
  if (!ltpPrice && ltpPrice !== 0) {
    return 0;
  }

  if (!closePrice) {
    return 0;
  }

  const diffrence = closePrice - ltpPrice;

  return diffrence;
}

const PriceDiffrenceBetween = ({ symbol }) => {
  const classes = useStyles();
  const ltp = useSelector((state) => {
    const value = getUnderlyingLiveFeed(state);

    const { ltp } = value[symbol] ? value[symbol] : {};

    return ltp;
  });

  const closePrice = useSelector((state) => {
    const value = getUnderlyingLiveFeedClosePrices(state);

    const { ltp } = value[symbol] ? value[symbol] : {};

    return ltp;
  });

  const diffrence = calculatePriceGap(ltp, closePrice);

  return (
    <div className={`${classes.root} PriceDiffrenceBetween`}>
      {diffrence.toFixed(2)}
    </div>
  );
};

export default PriceDiffrenceBetween;
